const React = require('react');
const {paramStore} = require('../../../../stores');
const withState = require('../../../../utils/withState');

const PaymentOrders = require('./components/PaymentOrders');
const PaymentHistory = require('./components/PaymentHistory');
const TabsHeading = require('./components/TabsHeading');

const tab$ = paramStore('tab', 'paymentOrders');

module.exports = withState(() => {
  return (state) => {
    const activeTab = state.tab;
    const tabs = {
      paymentOrders: PaymentOrders,
      paymentHistory: PaymentHistory,
    };
    const ActiveTab = tabs[activeTab];

    return (
      <div>
        <div className="h48 layoutRow jcSB aiC">
          <TabsHeading
            activeTab={activeTab}
            handleChange={(type) => {
              tab$.emit(type);
              paramStore('s').emit('');
            }}
          />
        </div>
        <div className="mt-48">
          <ActiveTab />
        </div>
      </div>
    );
  };
}, {
  tab: tab$,
});
